'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagEgAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 3.4697e-05C9.33335 3.4697e-05 18.6667 -4.89921e-05 28 4.35781e-05V20C18.6667 20 9.33337 20 3.93987e-05 20C3.93987e-05 13.3333 0.000293332 6.6667 0 3.4697e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.93987e-05 6.66667H28V8.88109e-06L0 0L3.93987e-05 6.66667Z",
          fill: "#E41D33"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3072 10.1051L11.588 8.66667H11.3333V10.7543L12.3072 10.1051ZM12.6667 10.6667L11.7031 11.309C11.2601 11.6044 10.6667 11.2868 10.6667 10.7543V8.66667C10.6667 8.29848 10.9652 8 11.3333 8H11.794C11.9203 8 12.0357 8.07133 12.0921 8.18426L12.6667 9.33333C12.6667 9.33333 12.8414 9.01522 13.0902 8.68975C13.3508 8.34891 13.6926 8 14 8C14.3346 8 14.6692 8.33582 14.9195 8.67038C15.1679 9.00247 15.3333 9.33333 15.3333 9.33333L15.9079 8.18426C15.9643 8.07133 16.0798 8 16.206 8H16.6667C17.0349 8 17.3333 8.29848 17.3333 8.66667V10.7543C17.3333 11.2868 16.7399 11.6044 16.2969 11.309L15.3333 10.6667H14.6667V11.3333C14.6667 11.7015 14.3682 12 14 12C13.6318 12 13.3333 11.7015 13.3333 11.3333V10.6667H12.6667ZM14.9213 10H13.0611L13.2506 9.65495L13.2556 9.64602C13.2598 9.6386 13.2666 9.62677 13.2756 9.61118C13.2938 9.57992 13.3211 9.5339 13.356 9.47811C13.4264 9.36528 13.5239 9.21847 13.635 9.07494C13.7493 8.92748 13.8618 8.80471 13.9597 8.72483C13.9808 8.70758 13.9983 8.69471 14.0123 8.68519C14.0279 8.69491 14.0481 8.7089 14.0731 8.72891C14.1682 8.80494 14.2755 8.92282 14.3833 9.06667C14.4883 9.20665 14.5784 9.35025 14.6429 9.46091C14.6748 9.51555 14.6995 9.56052 14.7157 9.59086C14.7238 9.60599 14.7298 9.61737 14.7334 9.62437L14.7371 9.63148L14.7375 9.6324L14.9213 10ZM15.6928 10.1051L16.6667 10.7543V8.66667H16.412L15.6928 10.1051Z",
          fill: "#C6A846"
        }
      )
    ]
  }
);
const VpFlagEgAsset = forwardRef(FlagEgAsset);

export { VpFlagEgAsset as default };
